import { useEffect, useRef } from 'react';

/**
 * Like useEffect, but skips the run that follows the very first render.
 *
 * Plain useEffect fires once on mount regardless of its dependency list. That
 * is the right behaviour for "fetch on load", but wrong for "reset something
 * when a filter changes" — a filter didn't change on mount, so resetting
 * there stomps whatever state was deliberately set up before first paint
 * (e.g. a list page number restored from navigation state after returning
 * from a detail view).
 */
function useUpdateEffect(effect, deps) {
  const isFirstRender = useRef(true);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return undefined;
    }
    return effect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
}

export default useUpdateEffect;
